<template>
	<div>
		<v-snackbar class="snackbar" :color="globalSnackColor" :timeout="4000" :right="true" :top="true" :value="globalSnackDisplay">
			{{ globalSnackMessage }}
		</v-snackbar>
		<v-container class="full_height" fluid="true" grid-list-lg text-xs-center ml-0 mr-0>
			<img src="../../assets/logo.png" class="mb-4" style="max-width: 275px;" />
			<v-layout row wrap>
				<v-flex xs12 offset-md3 md6 offset-lg4 lg4 >									
					<v-card>
						<v-card-text class="px-0">							
							<h2>Internet access required</h2><br />
							<p>Internet connection detected but unable to retrieve data.</p>
							<p>Please connect to the internet and press OK to restart.</p>
							<v-btn color="success" class="text-xs-right" @click.stop="fncCheckNetwork">OK</v-btn>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>		
	</div>
</template>

<script>

import router from '@/router';
export default {
	data () {
		return {			
		};
	},
	methods: {
		fncCheckNetwork() {
			router.replace('/');
		}
	}
};
</script>

<style>
	@import '../authentication/assets/css/auth.css'
</style>
